import { render, staticRenderFns } from "./IncommingCallCtrl.vue?vue&type=template&id=4b392b1d&lang=pug"
import script from "./IncommingCallCtrl.vue?vue&type=script&lang=js"
export * from "./IncommingCallCtrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports